export class ProductResolvedEvent extends Event {

  productCode: string | undefined
  url: string | undefined

  constructor (productCode: string, url: string) {
    super('ProductResolved')
    this.productCode = productCode
    this.url = url
  }
}
